import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const SessionActivityManager: React.FC = () => {
    const navigate = useNavigate();
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 minutes in milliseconds

    const handleLogout = () => {
        console.log("Session expired due to inactivity.");
        const isAdmin = !!localStorage.getItem('admin_token');
        localStorage.removeItem('token');
        localStorage.removeItem('admin_token');
        
        if (isAdmin) {
            navigate('/admin/login?expired=true');
        } else {
            navigate('/login?expired=true');
        }
    };

    const resetTimer = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // Only set timer if user is actually logged in
        if (localStorage.getItem('token') || localStorage.getItem('admin_token')) {
            timeoutRef.current = setTimeout(handleLogout, INACTIVITY_LIMIT);
        }
    };

    useEffect(() => {
        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

        const resetHandler = () => resetTimer();

        // Initialize timer
        resetTimer();

        // Add listeners
        events.forEach(event => {
            window.addEventListener(event, resetHandler);
        });

        // Cleanup
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            events.forEach(event => {
                window.removeEventListener(event, resetHandler);
            });
        };
    }, [navigate]);

    return null; // This component doesn't render anything
};

export default SessionActivityManager;
